import { render } from "./SearchContextIndicator.vue?vue&type=template&id=789a8465&scoped=true"
import script from "./SearchContextIndicator.vue?vue&type=script&lang=js"
export * from "./SearchContextIndicator.vue?vue&type=script&lang=js"

import "./SearchContextIndicator.vue?vue&type=style&index=0&id=789a8465&scoped=true&lang=css"

import exportComponent from "/build/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789a8465"]])

export default __exports__